export default __webpack_public_path__ + "static/media/AKM_7.12839682.png";